<template>
  <div>
    <div class="relative">
      <h4 style="color: #30384b !important" class="font-semibold my-2 md:my-0 mb-2">
        Tasks
      </h4>

      <!-- <div
        class="absolute flex h-4 w-4 blinker z-40 cursor-pointer"
        @click="showBlinkerTip"
        v-if="!blinkers.readBoardTasksTip"
        ref="wrapper"
      >
        <span
          class="animate-ping absolute inline-flex h-full w-full rounded-full opacity-50 blinker-color"
        ></span>
        <span
          class="relative inline-flex rounded-full h-full w-full blinker-color"
        ></span>
      </div>

      <div
        class="absolute blinker-details p-4 z-40"
        v-if="showBoardTasksTip"
        ref="blinkerTip"
      >
        <h5>Tasks that explain the Apps purpose</h5>
        <h5 class="font-semibold text-black my-2">
          "Break the Journey into small steps and the path becomes clear"
        </h5>
        <h5>
          Tasks broken down into steps allow you to understand the purpose. Each
          completed step will turn green as you complete it.
        </h5>

        <vs-button
          class="mt-2 float-right text-black font-semibold"
          @click="readFilterDown"
          >Got It</vs-button
        >
      </div> -->
    </div>
    <vx-card class="flex mt-4 p-4 pt-1 overflow-hidden w-full">
      <vs-row vs-lg="12" class="my-6 flex items-start" v-for="(i, index) in boardSteps" :key="index">
        <vs-col class="flex relative justify-center" vs-lg="1" vs-sm="1" vs-xs="1">
          <div class="icon relative items-center z-10" :class="index === 0 || i.reviewStatus === 'USER_ACCEPTED'
            ? 'active-icon'
            : 'inactive-icon'
            ">
            <!-- tick icon  -->
            <vs-avatar v-if="index === 0 || i.reviewStatus === 'USER_ACCEPTED'" color="#44CC88" icon="done" />
            <vs-avatar v-else color="#f2c244" size="30px" class="font-semibold" :text="`${index + 1}`" />
          </div>
          <div v-if="index < boardSteps.length - 2" class="absolute vertical-line" :class="[
            index === 0 || i.reviewStatus === 'USER_ACCEPTED'
              ? 'active-border'
              : 'inactive-border',
          ]" />
        </vs-col>

        <vs-col class="mt-0 ml-2 md:m-9 md:mt-0 md:mr-0" vs-w="10">
          <div class="text-left">
            <p class="cursor-pointer font-semibold text-lg" style="color: #383b46 !important">
              <b> {{ i.title }} </b>
            </p>
            <div>
              <span class="activity-desc text-base" v-if="i.description">{{ i.description }}
              </span>

              <div v-if="pendingStepIndex === index"
                class="p-4 shadow-md rounded-lg mt-4 flex items-center justify-between flex-wrap gap-2">
                <div class="flex-col" v-if="i.colData">
                  <span class="flex text-black font-semibold text-md">
                    Done with this step? Confirm to proceed.
                  </span>
                  <span class="flex text-black font-light italic text-sm">
                    Make sure you've completed the task before moving forward.
                  </span>
                </div>
                <span v-else class="text-black font-bold text-sm">
                  Waiting for your organization to take action. Please hold on
                  while your organization processes this step.
                </span>
                <div v-if="i.colData">
                  <vs-button @click.stop="getStepAction(i)" class="rounded-lg bg-green-400 hover:shadow">Complete
                    Task</vs-button>
                  <vs-button @click.stop="updateBoardStepStatus(i, 'yes')"
                    class="rounded-lg ml-4 bg-yellow-700 hover:shadow">Mark as done</vs-button>
                </div>
              </div>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vx-card>

    <!-- for joining casts/rooms  -->
    <vs-popup :title="popupTitle" :active.sync="isEventsPopup">
      <div class="flex flex-col gap-3" v-if="eventsLoading">
        <div class="bg-grey-500 p-10 rounded-lg animate-pulse" v-for="i in 5" :key="i"></div>
      </div>

      <div v-else>
        <div v-if="currentEvents.length > 0">
          <vs-card class="w-full mb-0" v-for="(event, i) in this.currentEvents" :key="i">
            <vs-col>
              <h4 class="flex gap-3 font-semibold text-lg">
                {{ event.event_name }}
                <div class="flex items-center gap-1 text-red-600" v-if="event.is_running === 'false'">
                  <span class="h-3 w-3 rounded-full bg-red-600 opacity-75"></span>
                  offline
                </div>

                <div v-else class="flex items-center gap-2 text-green-600">
                  <span class="animate-ping h-2 w-2 rounded-full bg-green-500 opacity-75"></span>
                  Live
                </div>
              </h4>
            </vs-col>
            <div class="flex items-center justify-between mt-2 w-full">
              <h6 class="text-slate-400">
                <span>{{ event.event_date }}</span>
                | <span>{{ formatTimestamp(event.event_time) }}</span>
              </h6>
              <vs-button class="rounded-lg p-2 text-black" @click.native="joinEvents(event)">Go to {{ popupTitle ===
                "Casts" ? "cast" : "room" }}</vs-button>
            </div>
          </vs-card>
        </div>

        <div v-else class="flex flex-col items-center justify-center">
          <img src="@/assets/images/empty-events.svg" alt="Empty" class="w-3/4" />
          <h4 class="normal-case">
            No <span class="lowercase">{{ popupTitle }}</span> are available at
            the moment.
          </h4>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import marketplaceList from "@/assets/data/marketplace-list.js";
import appFlow from "@/assets/data/app-flow.js";
import AppStep from "./AppStep.vue";
import { connectSocialSteps, web3Steps } from "@/assets/data/journeySteps.js";
import videowikiCastMixin from "../mixins/videowikiCastMixin";

export default {
  name: "user-board-step",
  props: {
    userLevelBoardAnalytics: {
      type: Object,
    },
  },
  mixins: [videowikiCastMixin],
  components: { AppStep },
  data() {
    return {
      appFlow,
      connectSocialSteps,
      web3Steps,
      marketplaceList,
      showBoardTasksTip: false,
      orgSlug: "",
      boardSteps: [],
      isEventsPopup: false,
      pendingStepIndex: 1,
      orgId: "",
      boardName: "",
    };
  },
  computed: {
    boardId() {
      return this.$route.params.boardId;
    },
    userData() {
      const ud = this.$store.state.users.data;
      if (ud.email) return ud;
      else return this.$store.state.auth.user;
    },
    blinkers() {
      return this.$store.state.dashboard.blinkers;
    },
  },
  watch: {
    userData() {
      this.fetchUserBoardProgress();
    },
    boardId: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.fetchUserBoardProgress();
        this.getBoardSteps();
      },
    },
  },
  methods: {
    getOrgDetails() {
      this.$store
        .dispatch("boards/fetchBoardDetails", this.boardId)
        .then((res) => {
          this.orgId = res.data.orgData._id;
          this.orgColor = res.data.orgData.primaryThemeColor;
          this.orgSlug = res.data.orgData.slug;
          this.boardName = res.data.title;
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    fetchUserBoardProgress() {
      if (this.userData && this.userData._id && this.boardId) {
        this.$store.dispatch("boards/fetchUserBoardProgress", {
          boardId: this.boardId,
          userId: this.userData._id,
        });
      }
    },
    readFilterDown() {
      this.showBoardTasksTip = false;
      this.$store.commit("dashboard/UPDATE_DASHBOARD_BLINKERS", {
        status: true,
        key: "readBoardTasksTip",
      });
    },
    handleClickOutside(event) {
      const popup = this.$refs.blinkerTip;
      const wrapper = this.$refs.wrapper;

      if (!popup.contains(event.target) && !wrapper.contains(event.target)) {
        this.showBoardTasksTip = false;
        window.removeEventListener("click", this.handleClickOutside);
      }
    },
    showBlinkerTip() {
      this.showBoardTasksTip = true;
      window.addEventListener("click", this.handleClickOutside);
    },
    getBoardSteps() {
      this.$store
        .dispatch("boards/fetchBoardSteps", {
          boardId: this.boardId,
          userId: this.userData._id,
        })
        .then((res) => {
          if (res && res.data) {
            for (let i = 0; i < res.data.length; i++) {
              if (
                res.data[i].reviewStatus === "PENDING" &&
                res.data[i].title !== "On Board"
              ) {
                if (i > 1) {
                  this.pendingStepIndex = i - 1;
                }
                break;
              }
            }
            this.boardSteps = res.data;
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    prepareMagicLinks(customUrl) {
      this.$store
        .dispatch("auth/generateMagicLink", {
          email: this.userData.email,
          loginCode: "1234",
          redirectTo: customUrl,
        })
        .then((res) => {
          let url = `https://api.coach.getboarded.com/oauth-auto?invitePhrase=${encodeURIComponent(
            res.data.invitePhrase
          )}`;
          window.open(url, "_blank");
        });
    },
    getStepAction(step) {
      if (step.colData) {
        let stepData = {};
        const { type, appSelected, appStepData } = step.colData;
        if (type === "customLink") {
          window.open(step.colData.customLink, "_blank");
        }
        if (type === "socialConnections") {
          stepData = this.connectSocialSteps.find(
            (socialStep) => socialStep.id === step.colData.socialStepData
          );
        } else if (type === "web3") {
          stepData = this.web3Steps.find(
            (web3Step) => web3Step.id === step.colData.web3StepData
          );
        } else if (type === "apps") {
          stepData = this.appFlow.flow[appSelected].steps.find(
            (appStep) => appStep.id === appStepData
          );
          if (appSelected === "coach" && stepData.customUrl) {
            this.prepareMagicLinks(stepData.customUrl);
          }
        }

        if (stepData.id === "joincast") {
          return this.getAllCasts(this.boardId);
        }

        if (stepData.id === "joinRoom") {
          return this.getAllRooms(this.boardId);
        }

        if (stepData && stepData.url) {
          this.routeToUrl(stepData.url);
        } else {
          console.error("Step data or URL is missing.");
        }
      }
    },
    routeToUrl(url) {
      let accessToken = localStorage.getItem("accessToken");
      let finalRoutingUrl = url
        .replace("${token}", accessToken)
        .replace("${orgId}", this.orgId)
        .replace("${orgSlug}", this.orgSlug)
        .replace("${firstName}", this.userData.firstName)
        .replace("${userEmail}", this.userData.email)
        .replace("${userId}", this.userData._id)
        .replace("${boardId}", this.boardId);
      window.open(finalRoutingUrl, "_blank");
    },
    joinEvents(event) {
      let { attendee_url, room_url, creator_email } = event;
      if (room_url) {
        return this.routeToUrl(room_url);
      }
      if (creator_email === this.userData.email) {
        this.$store
          .dispatch("videowiki/joinCastByCreator", {
            publicMeetingId: event.public_meeting_id,
            passkey: event.h_mp,
          })
          .then((res) => {
            window.open(res.cast_url, "_blank");
          })
          .catch((err) => {
            throw err;
          });
      } else {
        this.routeToUrl(attendee_url);
      }
      this.isEventsPopup = false;
    },
    updateBoardStepStatus(step, status) {
      if (status === "yes") {
        const payload = {
          boardId: this.boardId,
          kanbanColId: step.kanbanColId,
          userId: this.userData._id,
          reviewStatus: "USER_ACCEPTED",
        };
        this.$store
          .dispatch("boards/updateBoardStep", payload)
          .then((res) => {
            if (res && res.status === "SUCCESS") {
              this.$store
                .dispatch("kanban/getKanbanDataV2", this.boardId)
                .then((res) => {
                  if (res.data && res.data.status === "SUCCESS") {
                    const boardId = res.data.data.boardId;
                    const boardCols = res.data.data.cols;
                    const matchedData = boardCols.map((c) =>
                      c.colUsersData
                        .filter((u) => u.userId === payload.userId)
                        .map((m) => m)
                    );
                    matchedData.forEach((item, index) => {
                      if (item.length) {
                        let boardItemIndex = boardCols[
                          index
                        ].colUsersData.indexOf(item[0]);
                        boardCols[index].colUsersData.splice(boardItemIndex, 1);
                        boardCols[index + 1].colUsersData.push(item[0]);
                        let fromCol = boardCols[index].title;
                        let toCol = boardCols[index + 1].title;
                        let userName =
                          this.userData.firstName +
                          " " +
                          this.userData.lastName;
                        this.$store
                          .dispatch("kanban/updateKanbanV2", {
                            boardId: boardId,
                            cols: boardCols,
                          })
                          .then((res) => {
                            if (res.data && res.data.status === "SUCCESS") {
                              this.$store.dispatch(
                                "organization/logOrganizationActivity",
                                {
                                  organizationId: this.orgId,
                                  logObj: {
                                    logText: `Moved ${userName} from ${fromCol} to ${toCol} on ${this.boardName} Board`,
                                    status: "active",
                                    boardId: this.boardId,
                                    userId: this.userData._id,
                                  },
                                }
                              );
                            }
                          })
                          .catch((err) => {
                            throw err;
                          });
                      }
                    });
                  }
                });

              this.$vs.notify({
                text: "Step updated successfully !",
                iconPack: "feather",
                icon: "icon-check-circle",
                color: "success",
                fixed: false,
              });
              this.boardSteps[this.pendingStepIndex].reviewStatus =
                "USER_ACCEPTED";
              this.pendingStepIndex += 1;
            }
          })
          .catch((err) => {
            throw err;
          });
      }
    },
  },
  mounted() {
    this.getBoardSteps();
  },
  created() {
    this.fetchUserBoardProgress();
    this.getOrgDetails();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/components/vxTimeline.scss";

.blinker {
  left: 3.5em;
  top: 0.75em;

  &-color {
    background: rgba(var(--vs-primary, "#F2C244"), 1) !important;
  }

  &-details {
    background: #fae0a0;
    left: 3em;
    top: 2.5em;
    width: 25em;
    border-radius: 8px;
    z-index: 10;
  }
}
</style>

<style scoped>
.vx-card>>>.vx-card__body {
  padding: 0;
}

.vx-card>>>.vx-card__collapsible-content {
  width: 100%;
}
</style>
